import enTranslations from "@translations/en.json";

type TranslationKey = string;

// Simple translation function
export function t(key: TranslationKey): string {
  const keys = key.split(".");
  let value: any = enTranslations;

  for (const k of keys) {
    if (value && typeof value === "object" && k in value) {
      value = value[k];
    } else {
      // Return the key if translation not found (for debugging)
      console.warn(`Translation key not found: ${key}`);
      return key;
    }
  }

  return typeof value === "string" ? value : key;
}

// Type-safe translation helper hook
export function useTranslation() {
  return { t };
}
